"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var compat_1 = require("preact/compat");
var icon_1 = require("../../../constants/img/icon");
var ShopSellingFast = function () {
    var soldText = ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)("b", { class: "proxima-nova" }, "100k+ bottles sold"),
        " in the last month"));
    if (window.location.pathname.includes('endocrine')) {
        soldText = (0, preact_1.h)(preact_1.Fragment, null, "Strawberry Lemonade Flavored");
    }
    return ((0, preact_1.h)("div", { class: "shop-selling-fast ".concat(window.location.pathname.includes('endocrine') ? 'shop-selling-fast--flo-es' : '') },
        (0, preact_1.h)("img", { class: "shop-selling-fast__icon", src: icon_1.SELLING_FAST_ICON, alt: "selling fast" }),
        (0, preact_1.h)("span", { class: "shop-selling-fast__text" }, soldText)));
};
exports.default = (0, compat_1.memo)(ShopSellingFast);
